export interface IPoint {
	x: number;
	y: number;
}

export interface IOrientationPoint extends IPoint {
	angle:number;
}